<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Akses Laporan Eksekutif</h5>
            </template>
            <b-form id="changePasswordForm" @submit.prevent="openLapeks">
                <div class="form-content-wrapper">
                    <b-form-group label="Password" class="password-form-group">
                        <b-form-input v-model="input.passwordLaporan" name="passwordLaporan" :type="passwordType" required></b-form-input>
                        <i :class="passwordIconName" @click="changePasswordType()" ></i>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn">
                    <b-button variant="pgiBtn" name="changePasswordBtn" type="submit" :disabled="isSubmitting">
                        Lihat Laporan Eksekutif
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'akses-laporan-eksekutif',
    data(){
        return{
            input:{
                passwordLaporan: '',
            },

            isSubmitting: false,

            passwordType: 'password',
            passwordIconName: 'fa fa-eye-slash',
        }
    },
    methods: {
        openLapeks() {

            this.isSubmitting = true
            this.$axios.post(`laporan-eksekutif/check-password/?password=${this.input.passwordLaporan}`).then(response => {
                if(response.data == true){
                    localStorage.setItem('isauthorized', 'true')
                    localStorage.setItem('lapeksPassword', this.input.passwordLaporan)
                    this.$router.push("/laporan-eksekutif/laporan-omzet")
                    this.$emit("changeSidebarNav")
                }
            })
            .catch(error => {
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        //----------------- Fungsi Lain -----------------

        changePasswordType() {
            if(this.passwordType == 'password' && this.passwordIconName == 'fa fa-eye-slash') {
                this.passwordType = 'text'
                this.passwordIconName = 'fa fa-eye'
            }
            else {
                this.passwordType = 'password'
                this.passwordIconName = 'fa fa-eye-slash'
            }
        },
    },
}
</script>